import { listCareGroups } from "@/api/careGroups";
import { useResource } from "@/hooks/useResource";
import { Button } from "@/components/ui/Button";
import { Async } from "@/components/ui/Async";
import { Container, Eyebrow, SkeletonCards } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";
import { CareGroupCard } from "@/components/cards/Cards";
import { Link } from "@/router/Router";

/** Care groups teaser: areas covered and a few groups. */
export function CareGroups() {
  const groups = useResource("care-groups", (signal) => listCareGroups(signal));
  const areas = [...new Set((groups.data ?? []).map((g) => g.area).filter((a): a is string => Boolean(a)))].sort();

  return (
    <section className="cg-section" aria-labelledby="cg-title">
      <Container>
        <div className="cg-section__head">
          <div>
            <Reveal>
              <Eyebrow index="07" tone="leaf">
                Care groups
              </Eyebrow>
            </Reveal>
            <Reveal delay={60}>
              <h2 id="cg-title" className="cg-section__title">
                Church is better <em>close to home.</em>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={120} className="cg-section__lead">
            <p>Care groups meet across the city during the week — to pray, study the Word and look out for one another. Find one near you; many have bus pickup points on Sundays.</p>
            {groups.data?.length ? (
              <p className="cg-section__stats">
                <strong>{groups.data.length}</strong> groups{areas.length ? <> across <strong>{areas.length}</strong> areas</> : null}
              </p>
            ) : null}
            <Button to="/care-groups" variant="leaf" iconRight="arrowRight">
              Find a care group
            </Button>
          </Reveal>
        </div>
        {areas.length ? (
          <Reveal className="area-chips" delay={100}>
            {areas.slice(0, 14).map((a) => (
              <Link key={a} to={`/care-groups?area=${encodeURIComponent(a)}`} className="area-chip">
                {a}
              </Link>
            ))}
          </Reveal>
        ) : null}
        <Async resource={groups} compact skeleton={<SkeletonCards count={3} variant="text" />} empty={{ icon: "users", title: "Care groups are being updated", text: "Ask at any service, or email ask@miracleassembly.org to be connected." }}>
          {(list) => (
            <div className="cg-grid">
              {list.slice(0, 3).map((g, i) => (
                <Reveal key={g.id} delay={i * 80}>
                  <CareGroupCard group={g} />
                </Reveal>
              ))}
            </div>
          )}
        </Async>
      </Container>
    </section>
  );
}
